var React = require('react');

function ChevronRightLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.458806 18.5152C0.319137 18.3864 0.249343 18.2102 0.249343 18.0333C0.249343 17.8737 0.306462 17.7142 0.421999 17.5879L7.77919 9.50369L0.421837 1.41418C0.178087 1.14758 0.193321 0.731679 0.458651 0.486815C0.722714 0.240722 1.13262 0.257374 1.37637 0.523344L9.17637 9.05459C9.40745 9.30709 9.40745 9.6928 9.17637 9.94545L1.37637 18.4767C1.13156 18.7408 0.722868 18.7613 0.458806 18.5152Z","fill":"white"}));
}

ChevronRightLight.defaultProps = {"width":"10","height":"19","viewBox":"0 0 10 19","fill":"none"};

module.exports = ChevronRightLight;

ChevronRightLight.default = ChevronRightLight;
